var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-chart-global",attrs:{"id":"chart"}},[_c('apexchart',{staticClass:"chart-component",attrs:{"type":_vm.sTypeChart,"height":"410","width":_vm.screenWidth + 'px',"options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }